import { Beef, Fish, Flame, Gem, Mountain, Sprout } from 'lucide-react';

/** Terms §6 — National Capital Project Fund eligible sectors (display cards) */
export const RESOURCE_CATEGORIES = [
  {
    id: 'livestock',
    icon: Beef,
    items: ['camels', 'goats', 'sheep', 'cattle'],
  },
  {
    id: 'agriculture',
    icon: Sprout,
    items: [
      'Sorghum',
      'maize',
      'Wheat',
      'Sesame',
      'Fruits',
      'Vegetables',
      'BoswelliaCarterii',
      'BoswelliaFrereana',
      'Myrrh',
    ],
  },
  {
    id: 'fish',
    icon: Fish,
    groups: [
      { id: 'tuna', items: ['yellowfin', 'skipjack', 'albacore'] },
      { id: 'billfish', items: ['marlin', 'swordfish'] },
      { id: 'mackerel', items: ['kingMackerel', 'spanishMackerel'] },
      {
        id: 'reefFish',
        items: ['snapper', 'groupers', 'emperors', 'goatFish', 'sweetlips'],
      },
      { id: 'sharksRays', items: ['sharks', 'rays'] },
    ],
  },
  {
    id: 'miningMinerals',
    icon: Gem,
    items: [
      'lithium',
      'tantalum',
      'niobium',
      'titanium',
      'rareEarthElements',
      'tin',
      'copper',
      'lead',
      'zinc',
      'tungsten',
      'molybdenum',
      'manganese',
      'ironOre',
      'gypsumAnhydrite',
      'limestone',
      'marble',
      'dolomite',
      'feldspar',
      'mica',
      'silicaSand',
      'heavyMineralSands',
    ],
  },
  {
    id: 'oilGas',
    icon: Flame,
    items: ['onshoreExploration', 'offshoreExploration'],
  },
  {
    id: 'coal',
    icon: Mountain,
    items: ['coalExploration', 'coalDevelopment'],
  },
];
